module.exports = __webpack_public_path__ + "img/fw.3b689df5.png";